import { render, staticRenderFns } from "./EnviarAtaDialog.vue?vue&type=template&id=b890df22&scoped=true"
import script from "./EnviarAtaDialog.vue?vue&type=script&lang=js"
export * from "./EnviarAtaDialog.vue?vue&type=script&lang=js"
import style0 from "./EnviarAtaDialog.vue?vue&type=style&index=0&id=b890df22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b890df22",
  null
  
)

export default component.exports